// ------------------------------------------------------------------------------
// name: index
// author: mudas
// created: 2024-11-21
// ------------------------------------------------------------------------------

/**
 * 根据前端输入的 value 来筛选列出符合条件的 option 选项
 * @param fieldNames
 */
export const selectFilterOption =
  (fieldNames: { label: string; value: string } = { label: 'label', value: 'value' }) =>
  (inputValue: string, option: any): boolean => {
    const value = option[fieldNames.value] || option.props?.[fieldNames.value];
    const label = option[fieldNames.label] || option.title || option.props?.[fieldNames.label] || option.props?.title;
    const title = typeof option.children === 'string' ? option.children : option.children?.props?.title || '';

    // 对比标签时模糊匹配，对比value时等值匹配
    return (label || title).includes(inputValue) || value === inputValue || value === +inputValue;
  };
